import { MixinClassEffect } from './MixinClassEffect';
export class WindowEventEffect extends MixinClassEffect {
    constructor(eventName, eventHandlerFn) {
        super((active) => {
            if (active) {
                window.addEventListener(eventName, eventHandlerFn);
            }
            return () => {
                if (!active)
                    return;
                window.removeEventListener(eventName, eventHandlerFn);
            };
        });
    }
}

//# sourceMappingURL=WindowEventEffect.js.map
